import throttle from 'lodash/throttle';

const limit = 20;

export default class ListFeed {
	constructor(component, listModel, kind) {
		this.component = component;
		this.listModel = listModel;
		this.kind = kind;
	}

	/**
	 * @param component Vue component
	 * @param scrollerElement The DOM element that scrolls
	 * @param listElement The DOM element of the list
	 * @param {Object} listModel The model of list of entities. Implements add(entity), remove(entity)
	 * @param {Loader} loader Implements load(offset)
	 */
	init(loader, scrollerElement, listElement) {
		this.observer = this.listModel.createObserver(this);
		this.loader = loader;
		this.$scroller = $(scrollerElement);
		this.$listElement = $(listElement);

		this.loading = false;
		this.offset = 0;

		this.__onScroll = throttle(this._onScroll.bind(this), 20);
		this.$scroller.on('scroll', this.__onScroll);

		this.destroyed = false;

		return this._load().then(() => {
			if (!this.destroyed)
				this.observer.register();
		});
	}

	destroy() {
		this.observer.unregister();
		if (this.$scroller) {
			this.$scroller.off('scroll', this.__onScroll);
		}
		this.destroyed = true;
	}

	_load() {
		this.loading = true;

		return this.loader.load(this.offset).then(([children, allLoaded]) => {
			if (this.destroyed)
				return;

			for (let child of children) {
				this.listModel.add(child);
			}
			this.offset += children.length;
			this.loading = false;
			this.component.allEntitiesLoaded = allLoaded;

			setTimeout(() => { //in case not enough loaded to fill the page
				this.__onScroll();
			}, 10);
		});
	}

	_remove(entity) {
		throw 'Not implemented';
	}

	/** Implements store.Observer */
	onAdded(event, eventParams) {
		if (!this.loading && eventParams.kind === this.kind) {
			let added = 0;
			for (let entity of eventParams.entities) {
				if (this.listModel.add(entity, true))
					added += 1;
			}
			this.offset += added;
		}
	}

	/** Implements store.Observer */
	onRemoved(event, eventParams) {
		if (eventParams.kind === this.kind) {
			let component = this.component;
			for (let entity of eventParams.entities) {
				let removed = 0;
				if (this.listModel.remove(entity)) {
					removed += 1;
				}
				this.offset -= 1;
			}
		}
	}

	_onScroll() {
		if (this.loading || this.component.allEntitiesLoaded)
			return;

		const $scroller = this.$scroller;
		const scrollerHeight = $scroller.height();
		const scrollerScroll = $scroller.scrollTop();
		const $listElement = this.$listElement;
		const listBottom = $listElement.offset().top + $listElement.height();
		const listItemHeight = $listElement.find('li:first').height();

		if (listBottom < scrollerHeight + scrollerScroll + 2 * listItemHeight) {
			this._load();
		}
	}
}


// WEBPACK FOOTER //
// ./src/ui/widgets/listfeed.js